import dayjs from "dayjs";
import moment from "moment";
import _ from "lodash";

export default {
  install(Vue) {
    const helpers = {
      isEmpty(data) {
        if (
          data === undefined ||
          data === null ||
          (typeof data === "object" && Object.keys(data).length === 0) ||
          (typeof data === "string" && data.trim().length === 0)
        ) {
          return true;
        } else {
          return false;
        }
      },
      cutText(text, length) {
        if (text.split(" ").length > 1) {
          let string = text.substring(0, length);
          let splitText = string.split(" ");
          splitText.pop();
          return splitText.join(" ") + "...";
        } else {
          return text;
        }
      },
      formatDate(date1, format) {
        let date = new Date(date1);
        let offset = 0;
        let utc = date.getTime() + date.getTimezoneOffset() * 60000;
        var serverDate = new Date(utc + 3600000 * offset);
        return moment(serverDate).format(format);
      },
      capitalizeFirstLetter(string) {
        if (string) {
          return string.charAt(0).toUpperCase() + string.slice(1);
        }
      },
      onlyNumber(number) {
        if (number) {
          return number.replace(/\D/g, "");
        } else {
          return "";
        }
      },
      onlyNumberAndDot(number) {
        if (number) {
          if (number.charAt(0) == "0") {
            number = number.slice(1);
          }
          return number.replace(/[^0-9.]/g, "");
        } else {
          return "";
        }
      },
      filterCurrency(src) {
        if (!src) src = 0;
        //src = (src * 1).toFixed(2);
        const strSrc = src + "";
        let strPrefix = strSrc.split(".")[0];
        let strSuffix = strSrc.split(".")[1] || "";
        if (strSuffix !== "") strSuffix = "." + strSuffix;
        strPrefix = strPrefix.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return strPrefix + (strSuffix > 0 ? strSuffix : "");
        // return strPrefix;
      },
      isNumber: function(val) {
        var charCode = val;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          return false;
        } else {
          return true;
        }
      },
      convertCommaStrToInt(val) {
        val += "";
        return parseInt(val.replaceAll(",", ""));
      },
      convertCommaStrToFloat(val) {
        val += "";
        return parseFloat(val.replaceAll(",", ""));
      },
      cutNumber(number, cutAmount, type) {
        const modVal = number % cutAmount;
        // type = 1 : 절상, type = 2 : 절하
        if (type == 1) {
          number = number - modVal;
          number += cutAmount;
        } else {
          if (modVal == 0) {
            number -= cutAmount;
          } else {
            number = number - modVal;
          }
        }
        return number;
      },
      timeAgo(time) {
        let date = new Date(
            (time || "").replace(/-/g, "/").replace(/[TZ]/g, " ")
          ),
          diff = (new Date().getTime() - date.getTime()) / 1000,
          dayDiff = Math.floor(diff / 86400);

        if (isNaN(dayDiff) || dayDiff < 0 || dayDiff >= 31)
          return dayjs(time).format("MMMM DD, YYYY");

        return (
          (dayDiff == 0 &&
            ((diff < 60 && "just now") ||
              (diff < 120 && "1 minute ago") ||
              (diff < 3600 && Math.floor(diff / 60) + " minutes ago") ||
              (diff < 7200 && "1 hour ago") ||
              (diff < 86400 && Math.floor(diff / 3600) + " hours ago"))) ||
          (dayDiff == 1 && "Yesterday") ||
          (dayDiff < 7 && dayDiff + " days ago") ||
          (dayDiff < 31 && Math.ceil(dayDiff / 7) + " weeks ago")
        );
      },
      diffTimeByNow(time) {
        let startDate = dayjs(
          dayjs()
            .format("YYYY-MM-DD HH:mm:ss")
            .toString()
        );
        let endDate = dayjs(
          dayjs(time)
            .format("YYYY-MM-DD HH:mm:ss")
            .toString()
        );

        let duration = dayjs.duration(endDate.diff(startDate));
        let milliseconds = Math.floor(duration.asMilliseconds());

        let days = Math.round(milliseconds / 86400000);
        let hours = Math.round((milliseconds % 86400000) / 3600000);
        let minutes = Math.round(((milliseconds % 86400000) % 3600000) / 60000);
        let seconds = Math.round(
          (((milliseconds % 86400000) % 3600000) % 60000) / 1000
        );

        if (seconds < 30 && seconds >= 0) {
          minutes += 1;
        }

        return {
          days: days.toString().length < 2 ? "0" + days : days,
          hours: hours.toString().length < 2 ? "0" + hours : hours,
          minutes: minutes.toString().length < 2 ? "0" + minutes : minutes,
          seconds: seconds.toString().length < 2 ? "0" + seconds : seconds
        };
      },
      isset(obj) {
        if (obj !== null && obj !== undefined) {
          if (typeof obj === "object" || Array.isArray(obj)) {
            return Object.keys(obj).length;
          } else {
            return obj.toString().length;
          }
        }

        return false;
      },
      assign(obj) {
        return JSON.parse(JSON.stringify(obj));
      },
      randomNumbers(from, to, length) {
        let numbers = [0];
        for (let i = 1; i < length; i++) {
          numbers.push(Math.ceil(Math.random() * (from - to) + to));
        }

        return numbers;
      },
      findItemsFromArray(srcArray, value) {
        let result = [];
        _.map(srcArray, item => {
          if (item.name.indexOf(value) != -1) {
            result.push(item);
          }
        });
        return result;
      },
      findItemFromArray(srcArray, value) {
        let result = [];
        _.map(srcArray, item => {
          if (item.id === value) {
            result.push(item);
            return result;
          }
        });
        return result;
      },
      removeItemFromArray(srcArray, value) {
        let result = [];
        _.map(srcArray, item => {
          if (item.id !== value) {
            result.push(item);
          }
        });
        return result;
      }
    };

    Vue.prototype.$h = helpers;
  }
};
